const Banner = () => {
    return (
      <div className="banner">
        <div className="bannerContent">Drive Efficiency, Deliver Success</div>
      </div>
    );
  };

export default Banner